/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { currenciesBySite } from '../../helpers/currenciesBySite';

const siteId = process.env.REACT_APP_BUILD_SITE;
const { separator } = Object.values(currenciesBySite[siteId])[0];
const NumericInput = React.memo(
  React.forwardRef(({ name, ...rest }, ref) => {
    const onKeyDown = evt => {
      const code = evt.which ? evt.which : evt.keyCode;
      if (code === 187 || code === 188 || code === 189 || code === 190) {
        evt.preventDefault();
      }
    };
    const onInput = evt => {
      evt.target.value = evt.target.value.replace(/[^0-9]*/g, '');
      if (rest.formatnumber) {
        evt.target.value = evt.target.value.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${separator}`);
      }
    };
    return (
      <input
        name={name}
        onPaste={e => e.preventDefault()}
        onKeyDown={onKeyDown}
        onInput={onInput}
        ref={ref}
        {...rest}
      />
    );
  })
);

export { NumericInput };
